import React from 'react'
import Helmet from 'react-helmet'
import Typography from 'gatsby-theme-leshen/src/components/Typography'
import Enrollment from '../components/Enrollment'
import Layout from '../layouts'
import Hero from '../components/EnrollmentHero'
import heroImage from '../images/enrollment-hero.jpg'

const ForHomes = () => (
  <>
    <Layout>
      <Helmet htmlAttributes={{ lang: 'en-US' }}>
        <title>Residential Electricity & Gas | Just Energy</title>
        <meta
          name="description"
          content="Just Energy is committed to providing you with comfort, convenience, and control through home energy solutions that meet your needs. Get competitive energy rates for your home today!"
        />
      </Helmet>
      <Hero image={heroImage}>
        <Typography variant="h1">Get Started</Typography>
        <Typography variant="h4" rendersAs="h2">
          Get the best energy rates for your home with Just Energy.
        </Typography>
      </Hero>
      <main>
        <Enrollment basePath="/for-homes" />
      </main>
    </Layout>
  </>
)

export default ForHomes
